import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    loggedIn: false,
    access_token: null,
    selectedUserId: null
  },
  getters: {
    isLoggedIn (state) {
      return state.loggedIn
    },
    getAccessToken (state) {
      return state.access_token
    },
    getSelectedUserId (state) {
      return state.selectedUserId
    },
    getLoggedUserId (state) {
      if (state.access_token) {
        const tk = state.access_token as string
        const payload = JSON.parse(atob(tk.split('.')[1]))
        return payload.timestamp
      } else {
        return null
      }
    },
    getLoggedUserIdAndName (state) {
      if (state.access_token) {
        const tk = state.access_token as string
        const payload = JSON.parse(atob(tk.split('.')[1]))
        return { id: payload.timestamp, name: payload.username }
      } else {
        return null
      }
    },
    getUserRoles (state) {
      if (state.access_token) {
        const tk = state.access_token as string
        const payload = JSON.parse(atob(tk.split('.')[1]))
        return payload.roles
      } else {
        return []
      }
    }
  },
  mutations: {
    loggedIn (state, value) {
      state.loggedIn = value
    },
    accessToken (state, value) {
      state.access_token = value
    },
    selectedUserId (state, value) {
      state.selectedUserId = value
    }
  },
  actions: {
  },
  modules: {
  }
})
